export default {
  className: 'coupon',
  title: '物业费抵扣券',
  render: (record) => {
    return `${record.name}`
  },
  fields: [
    {
      name: 'name',
      validators: [
        (val) => val ? null : '优惠券名称不可为空'
      ]
    },
    {
      name: 'quota',
      note: '折扣百分比',
      validators: [
        (val) => val > 0 ? null : '请输入合理的数字',
        (val) => val ? null : '优惠券折扣额度不可为空'
      ]
    },
    {
      name: 'condition',
      validators: [
        (val) => val ? null : '充值金额不可为空'
      ]
    }
  ],
  search: [
    'name'
  ],
  action: {
    edit: false,
    delete: {
      type: 'row',
      text: '删除',
      callback: async ({ record, vm, modelName }) => {
        await vm.confirm('警告', '你确定要删除这条记录吗?')
        await vm.$tkParse.put(`/classes/coupon/${record.objectId}`, {
          isDel: true
        })
        vm.$notification['success']({
          message: '操作成功',
          description: '记录已被删除'
        })
        vm.refresh()
      }
    }
  },
  hooks: {
    beforeFetch ({ where }) {
      where.isDel = {
        $ne: true
      }
      where.couponType = {
        $ne: 'shopping'
      }
    },
    beforeInsert ({ data }) {
      data.isDel = false
      data.couponType = 'property'
    }
  }
}
